import React, { useEffect, useState } from 'react';

let manifestPromise = null;
function loadManifest() {
  if (!manifestPromise) {
    manifestPromise = fetch('/media/manifest.json')
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return manifestPromise;
}

export function mediaSrc(key, width = 1600) {
  return `/media/${key}-${width}.webp`;
}

// Responsive WebP image from the media pipeline (scripts/optimize-assets.js).
// `mediaKey` is "<project>/<slug>" as listed in public/media/manifest.json.
// Renders the blurred placeholder from the manifest until the real image
// loads; falls back gracefully when the manifest is missing.
export default function Picture({ mediaKey, alt = '', sizes = '100vw', className = '', imgClassName = '', priority = false, intrinsic = false, style }) {
  const [meta, setMeta] = useState(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let alive = true;
    loadManifest().then((m) => alive && setMeta(m[mediaKey] || null));
    return () => {
      alive = false;
    };
  }, [mediaKey]);
  // Only adopt the source's own aspect ratio when asked; long page
  // screenshots would otherwise stretch layouts that set their own ratio.
  const ratio = intrinsic && meta && meta.w && meta.h ? `${meta.w} / ${meta.h}` : undefined;
  return (
    <div
      className={`relative overflow-hidden bg-raised ${className}`}
      style={{ aspectRatio: ratio, backgroundImage: meta?.placeholder ? `url(${meta.placeholder})` : undefined, backgroundSize: 'cover', ...style }}
    >
      <img
        src={mediaSrc(mediaKey, 1600)}
        srcSet={`${mediaSrc(mediaKey, 800)} 800w, ${mediaSrc(mediaKey, 1600)} 1600w`}
        sizes={sizes}
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={`block h-full w-full object-cover transition-opacity duration-700 ${loaded ? 'opacity-100' : 'opacity-0'} ${imgClassName}`}
      />
    </div>
  );
}
